var sanitizeComponentDisplayName = function sanitizeComponentDisplayName(cn) {
  return cn.replace(/[^_a-z0-9-]/gi, '_').replace(/_{2,}/g, '_').replace(/(^_|_$)/g, '');
};

export default function generateSelectorPrefix(displayName, ruleName) {
  var sanitizedDisplayName = sanitizeComponentDisplayName(displayName);

  return ruleName ? sanitizedDisplayName + '_' + ruleName : sanitizedDisplayName;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/generateSelectorPrefix.js
// module id = 345
// module chunks = 0